import React from 'react';
import SuppliersList from './SuppliersList';

const SupplierManagement = ({ organization }) => {
  return <SuppliersList organization={organization} />;
};

export default SupplierManagement;
